module.exports = __webpack_public_path__ + "static/media/ChariteBerlin.cba78a63.png";